<div class="bankPageHolder">
    <app-loading-animation 
        [isRouting]="!bankPayWithCreditCardPage" 
        [margin]="'25px auto'"
        [width]="80"
        [height]="20"
        [background]="'none'"
    >
        <iframe
            [srcdoc]="bankPayWithCreditCardPage"
            class="bankPageIFrame"
            title="Kentkart 3dPayment"
        ></iframe>
    </app-loading-animation>
</div>